import { jsx } from 'react/jsx-runtime';
import * as Headlessui from '@headlessui/react';
import { Button } from '../../Button/Button.es.js';

const PopoverIconButton = ({ className, popupRole, locale = {
    openPopover: 'Open popover'
}, ...props })=>{
    return jsx(Headlessui.Popover.Button, {
        "aria-haspopup": popupRole,
        as: Button,
        className: className,
        label: locale.openPopover,
        variant: "secondary",
        iconOnly: true,
        ...props
    });
};
PopoverIconButton.displayName = 'Popover.PopoverButton';

export { PopoverIconButton };
//# sourceMappingURL=Popover.IconButton.es.js.map
